function setDefaultsImpl(_ref) {
  let {
    allowIcannDomains = true,
    allowPrivateDomains = false,
    detectIp = true,
    extractHostname = true,
    mixedInputs = true,
    validHosts = null,
    validateHostname = true
  } = _ref;
  return {
    allowIcannDomains,
    allowPrivateDomains,
    detectIp,
    extractHostname,
    mixedInputs,
    validHosts,
    validateHostname
  };
}
const DEFAULT_OPTIONS = /*@__INLINE__*/setDefaultsImpl({});
export function setDefaults(options) {
  if (options === undefined) {
    return DEFAULT_OPTIONS;
  }
  return (/*@__INLINE__*/setDefaultsImpl(options)
  );
}